/*
 * @Author: Yun
 * @Date: 2023-12-13 14:24:37
 * @Last Modified by: Yun
 * @Last Modified time: 2024-02-17 10:39:00
 */
import React, { useEffect, useState } from 'react'
import { Progress } from 'cgtd'
import { files as PRELOAD_FILES } from '@utils/preload.js'
import logo from '@icons/cgtn.jpg'
import $ from 'jquery'
import Html5Loader from '@utils/jquery.html5Loader.js'
import 'jquery.scrollto'
import './index.less'
const PREFIX = 'loading-page'

const twoColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
}

const conicColors = {
    '0%': '#87d068',
    '50%': '#ffe58f',
    '100%': '#ffccc7',
}

const Loading = (props) => {
    const [percent, setPercent] = useState(0)

    useEffect(() => {
        loader()
    }, [])

    const loader = () => {
        let preload_json = {
            files: PRELOAD_FILES,
        }

        Html5Loader({
            filesToLoad: preload_json,
            onBeforeLoad: () => {},
            onComplete: () => {
                setTimeout(() => {
                    $('body').scrollTo({ left: 0, top: 0 }, 0.1)
                    $(`.${PREFIX}`).css({ opacity: 0 })
                    $(`.${PREFIX}`).css({ zIndex: -1 })
                }, 1000)
            },
            onElementLoaded: (obj, elm) => {
                // console.log(obj)
            },
            onUpdate: (percentage) => {
                // console.log('percentage', percentage)
                setPercent(percentage)
            },
        })
    }

    return (
        <div className={`${PREFIX}`}>
            <div className={`${PREFIX}-wrapper`}>
                <div className={`${PREFIX}-title`}>
                    <img src={logo} alt="" />
                </div>
                <div className={`${PREFIX}-content`}>
                    <Progress
                        className={`${PREFIX}-progress-1`}
                        percent={percent}
                        strokeColor={twoColors}
                        showInfo={false}
                    />
                    <Progress
                        type="circle"
                        className={`${PREFIX}-progress-2`}
                        // size={15}
                        strokeWidth={9}
                        percent={percent}
                        strokeColor={conicColors}
                        trailColor={'#fff'}
                    />
                </div>
            </div>
        </div>
    )
}

export default Loading
